/*
 * Author: harper
 * File Created: Wednesday, 24-02-21 11:42 am
 * Last Modified: Thursday, 25-06-12 10:10 am, by Dw
 */

// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRewritesTunnelPath"] = "/dcscc/monitoring-tunnel";globalThis["SENTRY_RELEASE"] = {"id":"NkB8ODx0opO3ibz1PemsL"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "/dcscc";import * as Sentry from '@sentry/nextjs';

Sentry.init({
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
  release: process.env.NEXT_PUBLIC_COMMIT_HASH,

  // Adjust this value in production, or use tracesSampler for greater control
  tracesSampleRate: 0.1,

  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: false,

  // Capture Replay for 10% of all sessions,
  // plus for 100% of sessions with an error
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,

  // // You can remove this option if you're not planning to use the Sentry Session Replay feature:
  integrations: [
    Sentry.browserTracingIntegration(),
    // new Sentry.Replay({
    //   // Additional Replay configuration goes in here, for example:
    //   maskAllText: true,
    //   blockAllMedia: true,
    // },),
  ],
  denyUrls: [/^chrome-extension:\/\//],
  beforeSend(event, hint) {
    const error = hint.originalException;

    console.log('beforeSend Client error', error);

    // 检查是否有特定的状态码或错误类型
    // @ts-expect-error -- ignore
    if (error?.code === 'ECONNABORTED' || error?.ignoreSentry === true) {
      // 返回 null 表示不向 Sentry 上报此错误
      return null;
    }

    return event;
  },

  beforeSendTransaction(transaction) {
    // transaction.transaction 字段通常是路由名或你手动指定的名字
    if (
      transaction.transaction?.includes('/health-check') ||
      transaction.transaction?.includes('/.well-known/') ||
      transaction.transaction?.includes('/_error') ||
      transaction.transaction?.includes('/monitoring-tunnel')
    ) {
      return null; // 丢弃
    }

    return transaction;
  },
});
